import { render } from "./Paintings.vue?vue&type=template&id=e2cd00ba"
import script from "./Paintings.vue?vue&type=script&lang=js"
export * from "./Paintings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__